import { ComponentStyleConfig } from '@chakra-ui/react';

const ButtonSpinnerTheme: ComponentStyleConfig = {
  baseStyle: {
    marginRight: '4px'
  },
  sizes: {
    xs: {
      w: '16px',
      h: '16px',
      borderWidth: '2px'
    },
    sm: {
      w: '16px',
      h: '16px',
      borderWidth: '2px'
    },
    md: {
      w: '16px',
      h: '16px',
      borderWidth: '2px'
    },
    lg: {
      w: '20px',
      h: '20px',
      borderWidth: '2px'
    }
  }
};

export default ButtonSpinnerTheme;
